export * from './getNicknamesToComponentTypesMap.js';
